import { JsonApiDocument } from 'json-api-models';
import { reactive } from 'vue';

import { RevenueCatPackage } from '../app/utils/payments.ts';
import { AlertProps } from './alerts.ts';
import { models } from './models.ts';

export interface Payload {
    userId: string;
    documents: Record<string, JsonApiDocument>;
    alerts?: AlertProps[];
    appName: string;
    apiUrl?: string;
    aiModels?: {
        id: string;
        name: string;
        inputRate: number;
        outputRate: number;
        contextWindow: number | null;
    }[];
    products: RevenueCatPackage[];
    [key: string]: any;
}

const el = document.getElementById('emedici-payload');

export const payload: Payload = reactive(el ? JSON.parse(el.textContent || '{}') : {});

if (payload.documents) {
    for (const doc of Object.values(payload.documents)) {
        models.sync(doc);
    }
}
